import "./Account.css";

import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../Auth";

import { db } from "../base";
import { getDocs, query, where, collection } from "firebase/firestore";

import { Nav } from "../components/home-page/nav-section";
import { Footer } from "../components/home-page/footer-section";
import { UserAccount } from "../components/account-page/UserAccount";
import { AdminAccount } from "../components/account-page/AdminAccount";
import { SyncLoader } from "react-spinners";

export default function Account() {
  const { currentUser, authUserData } = useContext(AuthContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(null);
  const [licenseData, setLicenseData] = useState(null);

  useEffect(() => {
    const featchData = async (userId) => {
      setLoading(true);
      let userData = authUserData;
      // if admin get all access grants and email subscriptions
      if (userData.userType === "admin") {
        const accessSnap = await getDocs(collection(db, "access"));
        const subscribersQuerySnapshot = await getDocs(
          collection(db, "subscribers"),
        );
        setLicenseData(
          accessSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() })),
        );
        userData["subscribers"] = subscribersQuerySnapshot.docs.map((doc) =>
          doc.data(),
        );
        setUserData(userData);
      } else {
        // Unified "user": two independent, optional capabilities backed by two
        // separate email-keyed collections —
        //   owners/{email} = what you bought (management record),
        //   access/{email} = the one seat you consume (your personal access).
        const [ownerSnap, seatsSnap, mineSnap] = await Promise.all([
          // Seats I Manage — the owner record (providerUid == uid)…
          getDocs(
            query(collection(db, "owners"), where("providerUid", "==", userId)),
          ),
          // …plus every seat it backs (invitees + the owner's own consumed seat).
          getDocs(
            query(collection(db, "access"), where("providerUid", "==", userId)),
          ),
          // My Access — the single seat this user consumes (memberUid == uid).
          getDocs(
            query(collection(db, "access"), where("memberUid", "==", userId)),
          ),
        ]);

        const ownerGrant = ownerSnap.empty
          ? null
          : { id: ownerSnap.docs[0].id, ...ownerSnap.docs[0].data(), isOwner: true };
        const assignedSeats = seatsSnap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));
        // UserAccount reads ownerGrant via managedGrants.find(g => g.isOwner)
        // and assignedSeats via the rest.
        const managedGrants = ownerGrant
          ? [ownerGrant, ...assignedSeats]
          : assignedSeats;
        const myAccessGrant = mineSnap.empty
          ? null
          : { id: mineSnap.docs[0].id, ...mineSnap.docs[0].data() };

        setLicenseData({ managedGrants, myAccessGrant });
        setUserData(userData);
      }
      setLoading(false);
    };
    if (currentUser && authUserData) {
      featchData(currentUser.uid);
    } else {
      navigate("/login");
    }
  }, [currentUser, navigate]);

  if (!userData || loading) {
    return (
      <div className="loadingScreen">
        <SyncLoader color={"#e7b33e"} loading={loading} size={20} />
      </div>
    );
  }

  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      <Nav />
      {userData.userType === "admin" ? (
        <AdminAccount
          userData={userData}
          licenseData={licenseData}
          setUserData={setUserData}
          setLoading={setLoading}
          setLicenseData={setLicenseData}
        />
      ) : (
        <UserAccount
          userData={userData}
          licenseData={licenseData}
          setUserData={setUserData}
          setLoading={setLoading}
        />
      )}
      <div style={{ marginTop: "auto" }}>
        <Footer />
      </div>
    </div>
  );
}
